module.exports = __webpack_public_path__ + "static/reimageIT2-9d4599473cbdf656a5dd2f8f313e13e7.png";